@if (item.image) {
    <vn-image [src]="item.image.src" [alt]="item.image.alt" [width]="item.image.width" [height]="item.image.height" />
}
